/**
 * 🧚 RETENTION POPUP - Popup de rétention FRIENDLY avec PIXIE !
 * 
 * NON BLOQUANT - L'utilisateur peut TOUJOURS fermer facilement.
 * Design cool et décontracté.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { GuideAvatar } from './soul/GuideAvatar';

export const RetentionPopup = ({ 
  isOpen, 
  data, 
  onStay, 
  onLeave,
  isDarkMode = false 
}) => {
  // 🚨 DÉSACTIVER SUR HEARTBEATS.FR
  const hostname = window.location.hostname.toLowerCase();
  if (hostname.includes('heartbeats')) {
    return null;
  }
  
  // Ne pas afficher si pas ouvert ou pas de data
  if (!isOpen || !data) return null;

  // Handler sécurisé pour fermer
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onLeave) onLeave();
  };

  // Handler sécurisé pour rester
  const handleStay = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onStay) onStay();
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ 
        zIndex: 99999,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        pointerEvents: 'auto'
      }}
      onClick={handleClose}
    >
      {/* Modal */}
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        onClick={(e) => e.stopPropagation()}
        className={`relative max-w-xs w-full rounded-2xl p-5 text-center ${
          isDarkMode 
            ? 'bg-gray-900 border border-gray-700' 
            : 'bg-white border border-gray-200'
        }`}
        style={{
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
          pointerEvents: 'auto'
        }}
      >
        {/* Bouton X - GROS et VISIBLE */}
        <button
          type="button"
          onClick={handleClose}
          className={`absolute -top-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center shadow-lg ${
            isDarkMode 
              ? 'bg-gray-700 hover:bg-gray-600 text-white' 
              : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
          }`}
          style={{ zIndex: 100000 }}
        >
          <X className="w-5 h-5" />
        </button>

        {/* Pixie */}
        <div className="mb-3 flex justify-center">
          <GuideAvatar 
            guide="pixie" 
            expression="default"
            size="md"
          />
        </div>

        {/* Message court et friendly */}
        <h3 className={`text-lg font-semibold mb-1 ${
          isDarkMode ? 'text-white' : 'text-gray-900'
        }`}>
          {data.title || 'Tu pars déjà ?'}
        </h3>
        
        <p className={`text-sm mb-4 ${
          isDarkMode ? 'text-gray-400' : 'text-gray-600'
        }`}>
          {data.message || 'À bientôt ! 💜'}
        </p>

        {/* Boutons côte à côte */}
        <div className="flex gap-2">
          {/* Bouton Partir - À GAUCHE, bien visible */}
          <button
            type="button"
            onClick={handleClose}
            className={`flex-1 py-2.5 px-3 rounded-xl text-sm font-medium transition-colors ${
              isDarkMode 
                ? 'bg-gray-800 hover:bg-gray-700 text-gray-300' 
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Quitter
          </button>
          
          {/* Bouton Rester */}
          <button
            type="button"
            onClick={handleStay}
            className="flex-1 py-2.5 px-3 rounded-xl text-sm font-medium text-white transition-colors"
            style={{
              background: 'linear-gradient(135deg, #EC4899 0%, #8B5CF6 100%)'
            }}
          >
            💜 Rester
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default RetentionPopup;
